export default __webpack_public_path__ + "static/media/surgeon.3b1ce36e.svg";